<template>
  <div class="footer-component">
    <div class="footer-component">
      <footer class="footer -footer">
        <div class="container">
          <div class="content">
            <div class="columns">
              <div class="column is-4">
                <NewsletterForm />
              </div>
              <div class="column is-2"></div>
              <div class="column">
                <div class="navbar-item">
                  <p
                    class="is-size-6 has-text-weight-bold has-text-light is-uppercase has-text-centered-touch"
                  >
                    Main
                  </p>
                </div>
                <div
                  class="navbar-item has-text-centered-touch"
                  v-for="page in pages"
                  v-bind:key="page.title"
                  v-bind:class="{ 'has-text-weight-bold': page.isActivePage }"
                >
                  <router-link
                    v-bind:to="{ path: page.route }"
                    class="has-text-crowdflik-light"
                    >{{ page.title }}</router-link
                  >
                </div>
              </div>
              <div class="column">
                <div class="navbar-item">
                  <p
                    class="is-size-6 has-text-weight-bold has-text-light is-uppercase has-text-centered-touch"
                  >
                    Pages
                  </p>
                </div>
                <div
                  class="navbar-item has-text-centered-touch"
                  v-for="staticPage in staticPages"
                  v-bind:key="staticPage.title"
                  v-bind:class="{
                    'has-text-weight-bold': staticPage.isActivePage
                  }"
                >
                  <router-link
                    v-bind:to="{ path: staticPage.route }"
                    class="has-text-crowdflik-light"
                    >{{ staticPage.title }}</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div class="subfooter -subfooter -top-border has-padding-15">
        <div class="level has-text-centered-mobile">
          <div class="level-left">
            <div class="level-item">
              <span
                class="is-size-7 has-text-weight-semibold has-text-grey-lighter"
              >
                © 2019 CrowdFlik Inc., All Rights Reserved
              </span>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <div class="is-centered-mobile">
                <a
                  v-for="social in socials"
                  v-bind:key="social.name"
                  v-bind:href="social.url"
                  class="has-margin-left-5 has-margin-right-5"
                >
                  <b-button
                    v-bind:icon-right="social.icon"
                    v-bind:type="social.color"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NewsletterForm from "@/components/library/NewsletterForm.vue";

export default {
  name: "FooterComponent",
  computed: {
    ...mapState({
      pages: state => state.pages.pages,
      staticPages: state => state.pages.staticPages,
      socials: state => state.pages.socials
    })
  },
  components: {
    NewsletterForm
  }
};
</script>

<style scoped lang="scss">
.-subfooter {
  background-color: #212121;
}
</style>
